import React from "react";

export default function Section1() {
  return (
    <div>
      <section className="first-hightlight-wrapper">
        <div className="container">
          <div className="new-alert">New</div>

          <div className="title-wraper bold white">iPhone 14 Pro</div>
          <h5>Pro.Beyond.</h5>
          <div className="links-wrapper">
            <ul>
              <li>
                <a href="">Learn more</a>
              </li>
              <li>
                <a href="">Order</a>
              </li>
            </ul>
          </div>

          <div className="ipod-caption row">
            <div className="col-sm-12 col-md-6 text-md-right"></div>
            <div className="col-sm-12 col-md-6 text-md-left"></div>
          </div>
        </div>
      </section>
    </div>
  );
}
